import React, { useState, useEffect, useRef, forwardRef } from 'react';
import parse from 'html-react-parser';
import DatePicker, { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr"; // the locale you want
registerLocale("fr", fr);

import "react-datepicker/dist/react-datepicker.css";

import { languageController } from '../../../controllers/language/languageController';
import { useForm } from '../../../hooks/useForm';
import formLang from '../../../controllers/language/shared/form';
import { handleRequest } from '../../../utils/httpRequest';
import { getEndpointUrl } from '../../../utils/endPoints';
import { autoFormatPhoneNumber, convertLangCodeToSingleLetter, pushToGTMDataLayer, handleAnalyticsTrackingCodes } from '../../../utils/helpers';

import Input from '../../1_Atoms/Forms/Input/Input';
import Button from '../../1_Atoms/Button/Button';
import Textarea from '../../1_Atoms/Forms/Textarea/Textarea';
import Checkbox from '../../1_Atoms/Forms/Checkbox/Checkbox';
import Select from '../../1_Atoms/Forms/Select/Select';

import Form from '../../2_Molecules/Form/Form';
import FormGroup from '../../2_Molecules/FormGroup/FormGroup';
import FormContainer from '../../2_Molecules/FormContainer/FormContainer';
import FormConfirmation from '../../2_Molecules/FormConfirmation/FormConfirmation';

const CustomBirthInput = forwardRef(({ value, onClick }, ref) => (
  <div className="mz-form-item__textfield" onClick={onClick} ref={ref}>
    {value}
  </div>
));

function Nomination({ formExtraParams }) {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formError, setFormError] = useState(null)

  const { language, source, formHeading, formDisclaimer, formSubmitButtonText, formSubmitUrl } = formExtraParams

  function setDate(years){
    const date = new Date("November 1, 2023 01:00:00");
    if(years === 25){
      date.setDate(date.getDate() + 1);
    }
    return date.setFullYear( date.getFullYear() - years );
  }

  const [province, setProvince] = useState(document.querySelector('meta[name="province"]').getAttribute('content'));
  const [yourInfo_birthDate, setBirthdate] = useState(setDate(20));
  const [errorMessage, setErrorMessage] = useState(null)
  const [showReference, setShowReference] = useState(false);

  const [valFN, setValFN]= useState('');
  const [valLN, setValLN]= useState('');
  const [valEmail, setValEmail]= useState('');
  const [valPhone, setValPhone]= useState('');
  const [valConsent, setValConsent]= useState(false);

  const initState = {
    nominate_myself: false,

    yourInfo_firstname: '',
    yourInfo_lastname: '',
    yourInfo_email: '',
    yourInfo_phone: '',
    yourInfo_province:province,
    yourInfo_postalcode: '',
    yourInfo_consent: false,
    
    reference1_firstname: '',
    reference1_lastname: '',
    reference1_email: '',
    reference1_phone: '',

    duration_involvment: '',
    how_many:'',

    message: '',
    usage: '',

    form_consent: false,

    language: convertLangCodeToSingleLetter(language),
  }

  const validations = {
    yourInfo_firstname: ['required', 'name', 'nameMaxMin'],
    yourInfo_lastname: ['required', 'name', 'nameMaxMin'],
    yourInfo_email: ['required', 'email'],
    yourInfo_phone: ['required', 'phone'],
    yourInfo_postalcode: ['required', 'postalcode'],

    reference1_firstname:valFN,
    reference1_lastname:valLN,
    reference1_email:valEmail,
    reference1_phone:valPhone,
    yourInfo_consent: valConsent,

    message: ['required'],
    duration_involvment: ['required'],
    how_many: ['required'],
    usage: ['required'],

    //form_consent: ['required']
  }

  const { handleSubmit, handleChange, data, errors, setData } = useForm({
    initState,
    validations,
    // Send the form data if validated
    onSubmit: async () => {
      try {
        setIsSubmitting(true);
        // Remove whitespace in postalcode
        if (data.yourInfo_postalcode) {
          data.yourInfo_postalcode = data.yourInfo_postalcode.replace(/ /g, "");
        }
        
        // TODO: set the endpoint
        const formEndPointUrl = formSubmitUrl ? formSubmitUrl : getEndpointUrl('legend-nomination');
        const res = await handleRequest('post', formEndPointUrl, { ...data });
        
        if (res && res.Success === 'OK') {
          setIsSubmitted(true)
          setData(initState)
          document.querySelector('.mz-form-confirmation').scrollIntoView({block: 'center'});

          pushToGTMDataLayer({ formevent: 'submit' });
        } else {
          setFormError(res.state ? res.state : res.Errors[0])
        }
        setIsSubmitting(false)
      } catch (err) {
        console.log(err)
      }
    },
  })

  //scroll to error field
  useEffect(() => {
      const errorFields = document.querySelectorAll('.mz-form-item__error-message');
      let skipField = false;
      errorFields.forEach((field, index) => {
        if(field.innerHTML != '' && !skipField){
          field.scrollIntoView({block: 'center'});
          skipField=true;
        }
      });
  }, [errors])

  const ageMajority = {
    'AB' : 18,
    'BC' : 19,
    'MB' : 18,
    'NB' : 19,
    'NL' : 19,
    'NT' : 19,
    'NS' : 19,
    'NU' : 19,
    'ON' : 18,
    'PE' : 18,
    'QC' : 18,
    'SK' : 18,
    'YT' : 19
  };

  const {
    yourInfo_firstname,
    yourInfo_lastname,
    yourInfo_email,
    yourInfo_phone,
    yourInfo_postalcode,
    yourInfo_consent,

    reference1_firstname,
    reference1_lastname,
    reference1_email,
    reference1_phone,

    message,
    duration_involvment,
    how_many,
    usage,

    //form_consent
  } = data;

  function provinceChange(e){
    setProvince(e.target.value);
    setData({ ...data, yourInfo_province: e.target.value });
  }
  function fileChange(e){
    const file=e.target.files[0];
    
    //check file size
    if(e.target.files[0].size / 1024 / 1024 > 20){
      e.target.value='';
      setErrorMessage(languageController.getError('mb20'));
      e.target.parentElement.querySelector('.mz-form-item__filename').innerHTML='';
    }else{
      //base64 encode file
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        setData({ ...data, upload: reader.result })
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
      setErrorMessage(null);
    }
  }

  function birthChange(date){
    setBirthdate(date)
    setData({ ...data, yourInfo_birthDate: date.toISOString().slice(0,10).replace(/-/g,"/")})
  }

  useEffect(() => {
    const anchorDate = ageMajority[province] === 18 ? new Date("November 2, 2023 01:00:00") : new Date("November 3, 2023 01:00:00");
    const ageDifMs = anchorDate.getTime() - yourInfo_birthDate;
    const ageDate = new Date(ageDifMs); // miliseconds from epoch

    if(Math.abs(ageDate.getUTCFullYear() - 1970) < ageMajority[province]){
      setShowReference(true);
      

      setValFN(['required', 'name', 'nameMaxMin']);
      setValLN(['required', 'name', 'nameMaxMin']);
      setValEmail(['required', 'email']);
      setValPhone(['required', 'phone']);
      setValConsent(['required']);
    }else{
      setShowReference(false);
    
      setValFN('');
      setValLN('');
      setValEmail('');
      setValPhone('');
      setValConsent('');
     
    }
  }, [province, yourInfo_birthDate]);
  
  const inputRef = useRef(null);

  return (
    <div className="mz-nomination">
      <div className="mz-nomination__inner">
        <div className="mz-container">
          <div className="mz-full-width grid-inner-2-10-md grid-inner-3-8-lg">
            <FormContainer
              isSubmitted={isSubmitted}
              confirmation={(
                <FormConfirmation
                  heading={languageController.getCopy('nomination', 'confirmationHeading')}
                  subHeading={languageController.getCopy('nomination', 'confirmationSubHeading')}
                  firstName={yourInfo_firstname}
                  onClick={() => setIsSubmitted(false)}
                  isDark={false}
                />
              )}
            >
              <h2>{languageController.getCopy('nomination', 'heading')}</h2>
              <br/>
              <Form
                type="nomination"
                onSubmit={handleSubmit}
                isDark={false}
                noValidate={true}
                errorMessage={formError}
                requiredFieldsHelperText={true}
              >

                <p className="text--center">
                  <span className="h6"><strong>{languageController.getCopy('nomination', 'yourInformation')}</strong></span>
                </p>

                <FormGroup md={2}>
                  <Input
                    type="text"
                    name="yourInfo_firstname"
                    label={languageController.getFormCopy('label', 'firstname')}
                    value={yourInfo_firstname}
                    isRequired={true}
                    errorMessage={errors.yourInfo_firstname}
                    onChange={handleChange}
                    maxLength={50}
                  />
                  <Input
                    type="text"
                    name="yourInfo_lastname"
                    label={languageController.getFormCopy('label', 'lastname')}
                    value={yourInfo_lastname}
                    isRequired={true}
                    errorMessage={errors.yourInfo_lastname}
                    onChange={handleChange}
                    maxLength={50}
                  />
                  <Input
                    type="email"
                    name="yourInfo_email"
                    label={languageController.getFormCopy('label', 'email')}
                    value={yourInfo_email}
                    isRequired={true}
                    errorMessage={errors.yourInfo_email}
                    onChange={handleChange}
                    maxLength={320}
                  />
                  <Input
                    type="tel"
                    name="yourInfo_phone"
                    label={languageController.getFormCopy('label', 'phone')}
                    value={yourInfo_phone}
                    isRequired={true}
                    errorMessage={errors.yourInfo_phone}
                    onChange={(e) => {
                      setData({ ...data, yourInfo_phone: autoFormatPhoneNumber(e.target.value) });
                    }}
                    maxLength={17}
                  />
                  <Select
                      name="province"
                      label={languageController.getFormCopy('label', 'province')}
                      id="yourInfo_province"
                      value={province}
                      onChange={provinceChange}
                      placeholder={languageController.getFormCopy('label', 'select')}
                      options={formLang.select.provinces.map(subject => ({
                        value: subject[language + 'Short'],
                        label: subject[language]
                      }))}
                    />
                  <Input
                    type="text"
                    name="yourInfo_postalcode"
                    label={languageController.getFormCopy('label', 'postalcode')}
                    value={yourInfo_postalcode}
                    isRequired={true}
                    errorMessage={errors.yourInfo_postalcode}
                    onChange={handleChange}
                    maxLength={7}
                  />
                  <div className="mz-form-item--external-label">
                    <label className="label text--grey">
                      {languageController.getCopy('nomination', 'birthdate')}
                    </label>
                    <DatePicker
                      customInput={<CustomBirthInput inputRef={inputRef} />}
                      selected={yourInfo_birthDate}
                      onChange={date => birthChange(date)}
                      maxDate={setDate(15)}
                      minDate={setDate(25)}
                      locale={language}
                      dropdownMode="select"
                      showMonthDropdown
                      showYearDropdown
                      adjustDateOnChange
                      dateFormat="dd/MM/yyyy"
                    />
                  </div>
                </FormGroup>
                {showReference &&
                  <div>
                    <br/><br/>
                    <strong>{parse(languageController.getCopy('nomination', 'ageMajority'))}</strong>
                    <FormGroup md={2}>
                      <Input
                        type="text"
                        name="reference1_firstname"
                        label={languageController.getFormCopy('label', 'firstname')}
                        value={reference1_firstname}
                        isRequired={true}
                        errorMessage={errors.reference1_firstname}
                        onChange={handleChange}
                        maxLength={50}
                      />
                      <Input
                        type="text"
                        name="reference1_lastname"
                        label={languageController.getFormCopy('label', 'lastname')}
                        value={reference1_lastname}
                        isRequired={true}
                        errorMessage={errors.reference1_lastname}
                        onChange={handleChange}
                        maxLength={50}
                      />
                      <Input
                        type="email"
                        name="reference1_email"
                        label={languageController.getFormCopy('label', 'email')}
                        value={reference1_email}
                        isRequired={true}
                        errorMessage={errors.reference1_email}
                        onChange={handleChange}
                        maxLength={320}
                      />
                      <Input
                        type="tel"
                        name="reference1_phone"
                        label={languageController.getFormCopy('label', 'phone')}
                        value={reference1_phone}
                        isRequired={true}
                        errorMessage={errors.reference1_phone}
                        onChange={(e) => {
                          setData({ ...data, reference1_phone: autoFormatPhoneNumber(e.target.value) });
                        }}
                        maxLength={17}
                      />
                      <p>
                        <Checkbox
                          name="yourInfo_consent"
                          checked={yourInfo_consent}
                          value={yourInfo_consent}
                          required={true}
                          errorMessage={errors.yourInfo_consent}
                          onChange={(e) => setData({ ...data, yourInfo_consent: !yourInfo_consent })}
                          label={languageController.getFormCopy('label', 'consent')}
                          noLabelStyle={true}
                        />
                      </p>
                    </FormGroup>
                  </div>
                }

                 <br/>
                <p className="text--center">
                  <span className="h6"><strong>{languageController.getCopy('nomination', 'legendInitiative')}</strong></span>
                </p>
               
                <p>
                  {languageController.getCopy('nomination', 'shareDetailedInitiative')}
                </p>
                <div className="mz-form-item--external-label mz-form-involvment">
                  <label className="label text--grey">
                  {languageController.getFormCopy('label', 'whoBenefitEffort')}
                  </label>
                  <Textarea
                    name="message"
                    label={null}
                    value={message}
                    onChange={handleChange}
                    isRequired={true}
                    errorMessage={errors.message}
                    maxLength={2500}
                    rows={5}
                  />
                </div>
                <div className="mz-form-item--external-label mz-form-involvment">
                  <label className="label text--grey">
                    {parse(languageController.getFormCopy('label', 'durationInvolvment'))}
                  </label>
                  <Input
                    type="text"
                    name="duration_involvment"
                    label={null}
                    value={duration_involvment}
                    isRequired={true}
                    errorMessage={errors.duration_involvment}
                    onChange={handleChange}
                    maxLength={50}
                  />
                </div>
                <br/>
                <div className="mz-form-item--external-label mz-form-involvment">
                  <label className="label text--grey">
                    {parse(languageController.getFormCopy('label', 'howManyHelped'))}
                  </label>
                  <Input
                    type="text"
                    name="how_many"
                    label={null}
                    value={how_many}
                    isRequired={true}
                    errorMessage={errors.how_many}
                    onChange={handleChange}
                    maxLength={50}
                  />
                </div>
                <br/>
                <div className="mz-form-item--external-label mz-form-involvment">
                  <label className="label text--grey">
                  {languageController.getCopy('nomination', 'shareHow')}
                  </label>
                  <Textarea
                    name="usage"
                    label={null}
                    value={usage}
                    onChange={handleChange}
                    isRequired={true}
                    errorMessage={errors.usage}
                    maxLength={2500}
                    rows={5}
                  />
                </div>
                <div className="mz-form-item mz-form-item--external-label">
                  <label className="label text--grey">
                  {languageController.getFormCopy('label', 'fileDesc')}
                  </label>
                  <div className="mz-container-flex justify-left flex-no-gutter">
                    <input type="file" name="upload" className="mz-form-item__textfield mz-form-item__upload" id="upload" value="" onChange={fileChange} required="required" accept=".MP4, .MOV, .PDF, .JPG, .PNG" maxLength="255" autoComplete="off"/>
                    <label htmlFor="upload" className="mz-btn mz-btn--secondary"><span>{languageController.getFormCopy('label', 'file')}</span></label>
                    <div className="mz-form-item__filename"></div>
                  </div>
                  <label className="label text--grey ">
                  {parse(languageController.getFormCopy('label', 'fileTypes'))}
                  </label>
                  {errorMessage && <div className="mz-form-item__error-message">{errorMessage}</div>}
                  
                </div>
                <div className="mz-form-item label">
                  {formDisclaimer && parse(formDisclaimer)}
                </div>

                <Button
                  type="submit"
                  className="mz-btn--primary mz-btn--red"
                  label={formSubmitButtonText ? formSubmitButtonText : languageController.getCopy('nomination', 'submit')}
                  disabled={isSubmitting && 'disabled'}
                />
              </Form>
            </FormContainer>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Nomination
